'use strict';

angular.module('app').directive('heroSlider', function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var wall;

      $timeout(function() {

        $(element).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var element = $('.operator-slider .photos-list[data-slick-index="' + nextSlide + '"]');

          scope.$apply(function() {
            if (element.hasClass('general-photos')) {
              scope.activeSlider = "photos";
            } else if (element.hasClass('cabins-photos')) {
              scope.activeSlider = "cabins";
            } else if (element.hasClass('layout-photos')) {
              scope.activeSlider = "layout";
            } else if (element.hasClass('underwater-photos')) {
              scope.activeSlider = "underwater";
            } else if (element.hasClass('dive-center-photos')) {
              scope.activeSlider = "dive-center";
            }
          })
        });
      }, 300);

      scope.$watch('slidersImagesActive', function(newVal, oldVal) {
        if (typeof newVal !== 'undefined') {
          $('#photos .custom-loader').hide();

          // wall = new freewall(".mosaic");
        }

        if (newVal !== oldVal) {
          $(element).slick({
            speed: 0,
            arrows: false
          }).append('<button class="slick-prev slick-arrow"><button class="slick-next slick-arrow">');



          // $timeout(function() {
          //   wall.reset({
          //     selector: '.brick',
          //     animate: false,
          //     cellW: 500,
          //     cellH: 'auto',
          //     fixSize: 0,
          //     gutterY: 20,
          //     gutterX: 20,
          //     onResize: function() {
          //       wall.refresh($(window).width(), $('.operator-slider').height());
          //     }
          //   });

          //   wall.fitZone($(window).width() - 30,$('.operator-slider').height());
          // },150);
        }
      });
    }
  };
});